import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalShopSettings from "@faire/web-api--source/routes/brand-portal/my-shop/settings";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";

export const OnlineOnlyRetailersIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="Retailers who sell exclusively online, and do not have a physical retail location are considered <BoldFormatting>online-only retailers</BoldFormatting>. Retailers who exclusively sell on social media platforms like Facebook or Instagram are considered <BoldFormatting>social sellers</BoldFormatting>."
          values={{
            BoldFormatting,
          }}
          description={{
            text: "Introduction to online-only retailers and social sellers",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="You can choose whether or not you’d like to sell to online-only retailers and social sellers. If you turn off access, your shop will be hidden to these types of retailers. Here’s how to update your preferences:"
          description={{
            text: "Instructions to update preferences for online-only retailers",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ol>
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Navigate to the <BoldFormatting>Settings</BoldFormatting> page."
              values={{
                BoldFormatting,
              }}
              description={{
                text: "First step to update preferences",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={2}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Select <LinkFormatting>Shop settings</LinkFormatting> and scroll down to <BoldFormatting>Retailer options</BoldFormatting>."
              values={{
                LinkFormatting: ShopSettingsLinkFormatting,
                BoldFormatting,
              }}
              description={{
                text: "Second step to update preferences",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={3}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Toggle <BoldFormatting>online-only retailer</BoldFormatting> and <BoldFormatting>social seller</BoldFormatting> options on or off."
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Third step to update preferences",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={4}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Save</BoldFormatting> any changes."
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Fourth step to update preferences",
              }}
            />
          </Typography>
        </LiItem>
      </ol>
    </Column>
  );
};

const ShopSettingsLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalShopSettings()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
